import React from "react";
import { StyledFooter, StyledText } from "./index.styled";

export default function Footer() {
  return (
    <StyledFooter>
      <StyledText>
        Ovo anketno ispitivanje se sprovodi u okviru aktivnosti „Digitalizacija
        poljoprivrede u Novom Pazaru“ čiji je nosilac SEDA, uz podršku Projekta
        „Velika mala privreda“, koji finansira USAID, a sprovodi ACDI/VOCA. Cilj
        prikupljanja i digitalizacije podataka je dobijanje realnog uvida u
        potencijale sektora poljoprivrede u regionu Novog Pazara i pokretanje
        konkretnih inicijativa koje treba da pomognu njegov dalji razvoj.
      </StyledText>
    </StyledFooter>
  );
}
